import { Button } from '@progress/kendo-react-buttons';
import clsx from 'clsx';
import React from 'react';
import { SubscriptionPlanBenefitsList } from '../../../SubscriptionPlanFeaturesList';
import './SubscriptionPlanCard.less';
import renderTextContent, {
  TextContentType,
} from 'utils/text/renderTextContent';
import { SkeletonText } from 'app/components/skeletons';
import { SubscriptionPlanBenefitsListItem } from '../../../../components/SubscriptionPlanFeaturesList/SubscriptionPlanBenefitsList';
import { Divider } from 'app/components/Divider';

export interface SubscriptionPlanCardProps {
  isCurrent?: boolean;
  title: TextContentType;
  subtitle: TextContentType;
  isSubtitleLoading?: boolean;
  buttonLabel: string;
  buttonDetails?: TextContentType;
  isButtonLoading?: boolean;
  featuresTitle: TextContentType;
  features: SubscriptionPlanBenefitsListItem[];
  featuresDescription?: string;
  onUpgrade?: () => void;
}

export default function SubscriptionPlanCard({
  isCurrent,
  title,
  subtitle,
  isSubtitleLoading,
  buttonLabel,
  buttonDetails,
  isButtonLoading,
  featuresTitle,
  features,
  onUpgrade,
}: SubscriptionPlanCardProps) {
  return (
    <div
      className={clsx('subscription-plan-card', {
        'subscription-plan-card_current': isCurrent,
      })}
    >
      <div className="subscription-plan-card__header">
        <h4 className="subscription-plan-card__title">
          {renderTextContent(title)}
        </h4>

        {isSubtitleLoading ? (
          <SkeletonText className="subscription-plan-card__subtitle" />
        ) : (
          <p className="subscription-plan-card__subtitle">
            {renderTextContent(subtitle)}
          </p>
        )}

        <h5 className="subscription-plan-card__features-title">
          {renderTextContent(featuresTitle)}
        </h5>

        {!isCurrent ? (
          <Button
            className="subscription-plan-card__action-button"
            themeColor="primary"
            disabled={isButtonLoading}
            onClick={onUpgrade}
          >
            <div className="equipment-selection-view__continue-btn-content">
              {buttonLabel}

              {buttonDetails && (
                <span className="equipment-selection-view__equipment-selected-text">
                  {renderTextContent(buttonDetails)}
                </span>
              )}
            </div>
          </Button>
        ) : (
          <Button
            className="subscription-plan-card__action-button subscription-plan-card__current-button"
            themeColor="light"
            disabled
          >
            <div className="equipment-selection-view__continue-btn-content">
              {buttonLabel}
            </div>
          </Button>
        )}
      </div>

      <Divider />

      <div className="subscription-plan-card__list">
        <SubscriptionPlanBenefitsList items={features} />
      </div>
    </div>
  );
}
